import React, { useState, useEffect } from 'react';
import logo from '../../utils/images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { login, UserDetails } from '../../redux/actions/authActions';
import { TextField, Button, CircularProgress, Box, Typography } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import './Styles.scss';

const LoginComp = () => {

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };


  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({ email: '', password: '' });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, auth_token, user } = useSelector((state) => state.auth);
  const handleChange = (e) => {
    const {name,value}= e.target;
    setFormData(formData=>({...formData,[name]:value}));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;

    if (!formData.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: 'Email is required' }));
      valid = false;
    }

    if (!formData.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: 'Password is required' }));
      valid = false;
    }

    if (valid) {
      const result = await dispatch(login(formData.email, formData.password));
      // Login action now calls UserDetails internally, so we just need to wait for auth_token
      // Navigation will happen in useEffect when auth_token and user are available
    }    
  };  
  useEffect(()=>{
      // Check both Redux state and sessionStorage for user data
      const sessionUser = sessionStorage.getItem('user');
      const hasUser = user || sessionUser;
      
      if(auth_token && hasUser){
        // Both auth_token and user data are available, safe to navigate
        navigate("/report"); 
      }
  },[auth_token, user, navigate])
  return (
    <Box>
        <Box className="loginMain">
          <Box className="loginBoxInn">
            <Box>
              <img src={logo} alt='' className='logo-img'/>
            </Box>
            <Typography 
                component="h1" 
                variant="h4" 
                mb={2}
                sx={{
                    fontSize: { xs: '1.5rem', sm: '2rem' }, // Smaller on mobile
                    fontWeight: 500
                }}
            >
                Login
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate gap={'15px'} display={'flex'} flexDirection={'column'} width={'100%'}>
                <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.email}
                onChange={(e) => {
                    handleChange(e);
                }}
                error={!!errors.email}
                helperText={errors.email}
                />
                <FormControl variant="outlined">
          <InputLabel htmlFor="password">Password</InputLabel>
          <OutlinedInput
            id="password"
            required
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            value={formData.password}
            name="password"
            onChange={(e) => {
              handleChange(e);
            }}
            error={!!errors.password}
            helperText={errors.password}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                >
                {loading ?  <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Login'}
                </Button>
                <Box textAlign={"right"} style={{ color: '#8BAF91' }}>
                  <Link to="/forgot-password" style={{ color: '#8BAF91' }} variant="body2">
                      Forgot password?
                  </Link>
                </Box>
            </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default LoginComp;
